import React from "react";
import {autobind} from "core-decorators";
import {observer} from "mobx-react";
import {Table} from "antd";
import _isEmpty from "lodash/isEmpty";

import {PiecesQuery} from "@/graphql/types";
import TablePiecesActions from "./TablePiecesActions/TablePiecesActions";

type Pieces = PiecesQuery["pieces"];
type Piece = Pieces[0];

export interface ITablePendingPiecesProps {
  pendingPieces?: Pieces;
  pieces?: Pieces;
}

@autobind
@observer
export default class TablePendingPieces extends React.Component<ITablePendingPiecesProps> {
  renderCreatedAtColumn(text: any, record: Piece, index: number): React.ReactNode {
    return new Date(text).toLocaleString();
  }

  renderLanguageColumn(language: string, piece: Piece, index: number): React.ReactNode {
    return language.charAt(0).toUpperCase() + language.slice(1); // Upper case for the first letter
  }

  renderStatusColumn(status: string, piece: Piece, index: number): React.ReactNode {
    return <span style={{whiteSpace: "nowrap"}}>{status}</span>;
  }

  public render() {
    const {pendingPieces, pieces} = this.props;
    if (_isEmpty(pendingPieces)) return null;
    // observe piece attributes so we re-render when they are changed in an action
    const piecesAttrs = pieces?.map((p) => [p.folder, p.title, p.composer, p.created_at, p.status]); // eslint-disable-line
    return (
      <>
        <Table<Piece>
          className="TablePendingPieces"
          // we need to create a new array to trigger a re-render of the table component (for deleted elements)
          dataSource={pendingPieces?.slice()}
          rowKey="id"
          loading={!pendingPieces}
          pagination={false}
          style={{marginBottom: "3em"}}
          scroll={{x: true}}
        >
          <Table.Column<Piece>
            title="Actions"
            key="actions"
            render={(_, piece) => <TablePiecesActions piece={piece} pieces={pieces!} />}
          />
          <Table.Column<Piece>
            title="Title"
            dataIndex="title"
            key="title"
            className="title"
            // Use a new lambda in render so the cell gets updated when it changes
            render={(title) => title}
          />
          <Table.Column<Piece>
            title="Composer"
            dataIndex="composer"
            key="composer"
            className="composer"
            // Use a new lambda in render so the cell gets updated when it changes
            render={(composer) => composer}
          />
          <Table.Column<Piece>
            title="Language"
            dataIndex="language"
            key="language"
            render={this.renderLanguageColumn}
            className="language"
          />
          <Table.Column<Piece>
            title="Created at"
            dataIndex="created_at"
            key="created_at"
            render={this.renderCreatedAtColumn}
          />
          <Table.Column<Piece>
            title="Status"
            dataIndex="status"
            key="status"
            className="status"
            // Use a new lambda in render so the cell gets updated when it changes
            render={(...args) => this.renderStatusColumn(...args)}
          />
        </Table>
      </>
    );
  }
}
